export default "__VITE_ASSET__C461h6No__"